// source: authz/authz.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var authz_permissions_pb = require('../authz/permissions_pb.js');
goog.object.extend(proto, authz_permissions_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
var authz_roles_pb = require('../authz/roles_pb.js');
goog.object.extend(proto, authz_roles_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.authz.AccessRole', null, global);
goog.exportSymbol('proto.authz.BASE_ACCESS_ROLE', null, global);
goog.exportSymbol('proto.authz.BaseAccessRoleUpdate', null, global);
goog.exportSymbol('proto.authz.CreateAccessRoleRequest', null, global);
goog.exportSymbol('proto.authz.DeleteAccessRoleRequest', null, global);
goog.exportSymbol('proto.authz.DomainRoles', null, global);
goog.exportSymbol('proto.authz.GetAccessRolesRequest', null, global);
goog.exportSymbol('proto.authz.GetAccessRolesResponse', null, global);
goog.exportSymbol('proto.authz.GetPermissionsResponse', null, global);
goog.exportSymbol('proto.authz.PermissionOverrides', null, global);
goog.exportSymbol('proto.authz.UpdateAccessRoleRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.DomainRoles = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.authz.DomainRoles, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.DomainRoles.displayName = 'proto.authz.DomainRoles';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.PermissionOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.authz.PermissionOverrides.repeatedFields_, null);
};
goog.inherits(proto.authz.PermissionOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.PermissionOverrides.displayName = 'proto.authz.PermissionOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.AccessRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.authz.AccessRole.repeatedFields_, null);
};
goog.inherits(proto.authz.AccessRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.AccessRole.displayName = 'proto.authz.AccessRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.GetPermissionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.authz.GetPermissionsResponse.repeatedFields_, null);
};
goog.inherits(proto.authz.GetPermissionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.GetPermissionsResponse.displayName = 'proto.authz.GetPermissionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.GetAccessRolesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.authz.GetAccessRolesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.GetAccessRolesRequest.displayName = 'proto.authz.GetAccessRolesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.GetAccessRolesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.authz.GetAccessRolesResponse.repeatedFields_, null);
};
goog.inherits(proto.authz.GetAccessRolesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.GetAccessRolesResponse.displayName = 'proto.authz.GetAccessRolesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.BaseAccessRoleUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.authz.BaseAccessRoleUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.BaseAccessRoleUpdate.displayName = 'proto.authz.BaseAccessRoleUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.CreateAccessRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.authz.CreateAccessRoleRequest.repeatedFields_, null);
};
goog.inherits(proto.authz.CreateAccessRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.CreateAccessRoleRequest.displayName = 'proto.authz.CreateAccessRoleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.UpdateAccessRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.authz.UpdateAccessRoleRequest.repeatedFields_, null);
};
goog.inherits(proto.authz.UpdateAccessRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.UpdateAccessRoleRequest.displayName = 'proto.authz.UpdateAccessRoleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.DeleteAccessRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.authz.DeleteAccessRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.DeleteAccessRoleRequest.displayName = 'proto.authz.DeleteAccessRoleRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.DomainRoles.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.DomainRoles.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.DomainRoles} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.DomainRoles.toObject = function(includeInstance, msg) {
  var f, obj = {
    controls: jspb.Message.getFieldWithDefault(msg, 1, 0),
    policies: jspb.Message.getFieldWithDefault(msg, 2, 0),
    evidence: jspb.Message.getFieldWithDefault(msg, 3, 0),
    risks: jspb.Message.getFieldWithDefault(msg, 4, 0),
    services: jspb.Message.getFieldWithDefault(msg, 5, 0),
    receptors: jspb.Message.getFieldWithDefault(msg, 6, 0),
    frameworks: jspb.Message.getFieldWithDefault(msg, 7, 0),
    audits: jspb.Message.getFieldWithDefault(msg, 8, 0),
    requests: jspb.Message.getFieldWithDefault(msg, 9, 0),
    reports: jspb.Message.getFieldWithDefault(msg, 10, 0),
    roadmap: jspb.Message.getFieldWithDefault(msg, 11, 0),
    dashboards: jspb.Message.getFieldWithDefault(msg, 12, 0),
    users: jspb.Message.getFieldWithDefault(msg, 13, 0),
    scope: jspb.Message.getFieldWithDefault(msg, 14, 0),
    accountDetails: jspb.Message.getFieldWithDefault(msg, 15, 0),
    auditScans: jspb.Message.getFieldWithDefault(msg, 16, 0),
    chats: jspb.Message.getFieldWithDefault(msg, 17, 0),
    trustPortal: jspb.Message.getFieldWithDefault(msg, 18, 0),
    questionnaires: jspb.Message.getFieldWithDefault(msg, 19, 0),
    accountSettings: jspb.Message.getFieldWithDefault(msg, 20, 0),
    vendors: jspb.Message.getFieldWithDefault(msg, 21, 0),
    grcDocuments: jspb.Message.getFieldWithDefault(msg, 22, 0),
    playbooks: jspb.Message.getFieldWithDefault(msg, 23, 0),
    accessRoles: jspb.Message.getFieldWithDefault(msg, 24, 0),
    departments: jspb.Message.getFieldWithDefault(msg, 25, 0),
    companyInfo: jspb.Message.getFieldWithDefault(msg, 26, 0),
    schedules: jspb.Message.getFieldWithDefault(msg, 27, 0),
    contentVersions: jspb.Message.getFieldWithDefault(msg, 28, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.DomainRoles}
 */
proto.authz.DomainRoles.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.DomainRoles;
  return proto.authz.DomainRoles.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.DomainRoles} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.DomainRoles}
 */
proto.authz.DomainRoles.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.authz.ControlsRole} */ (reader.readEnum());
      msg.setControls(value);
      break;
    case 2:
      var value = /** @type {!proto.authz.PoliciesRole} */ (reader.readEnum());
      msg.setPolicies(value);
      break;
    case 3:
      var value = /** @type {!proto.authz.EvidenceRole} */ (reader.readEnum());
      msg.setEvidence(value);
      break;
    case 4:
      var value = /** @type {!proto.authz.RisksRole} */ (reader.readEnum());
      msg.setRisks(value);
      break;
    case 5:
      var value = /** @type {!proto.authz.ServicesRole} */ (reader.readEnum());
      msg.setServices(value);
      break;
    case 6:
      var value = /** @type {!proto.authz.ReceptorsRole} */ (reader.readEnum());
      msg.setReceptors(value);
      break;
    case 7:
      var value = /** @type {!proto.authz.FrameworksRole} */ (reader.readEnum());
      msg.setFrameworks(value);
      break;
    case 8:
      var value = /** @type {!proto.authz.AuditsRole} */ (reader.readEnum());
      msg.setAudits(value);
      break;
    case 9:
      var value = /** @type {!proto.authz.RequestsRole} */ (reader.readEnum());
      msg.setRequests(value);
      break;
    case 10:
      var value = /** @type {!proto.authz.ReportsRole} */ (reader.readEnum());
      msg.setReports(value);
      break;
    case 11:
      var value = /** @type {!proto.authz.RoadmapRole} */ (reader.readEnum());
      msg.setRoadmap(value);
      break;
    case 12:
      var value = /** @type {!proto.authz.DashboardsRole} */ (reader.readEnum());
      msg.setDashboards(value);
      break;
    case 13:
      var value = /** @type {!proto.authz.UsersRole} */ (reader.readEnum());
      msg.setUsers(value);
      break;
    case 14:
      var value = /** @type {!proto.authz.ScopeRole} */ (reader.readEnum());
      msg.setScope(value);
      break;
    case 15:
      var value = /** @type {!proto.authz.AccountDetailsRole} */ (reader.readEnum());
      msg.setAccountDetails(value);
      break;
    case 16:
      var value = /** @type {!proto.authz.AuditScanRole} */ (reader.readEnum());
      msg.setAuditScans(value);
      break;
    case 17:
      var value = /** @type {!proto.authz.ChatsRole} */ (reader.readEnum());
      msg.setChats(value);
      break;
    case 18:
      var value = /** @type {!proto.authz.TrustPortalRole} */ (reader.readEnum());
      msg.setTrustPortal(value);
      break;
    case 19:
      var value = /** @type {!proto.authz.QuestionnairesRole} */ (reader.readEnum());
      msg.setQuestionnaires(value);
      break;
    case 20:
      var value = /** @type {!proto.authz.AccountSettingsRole} */ (reader.readEnum());
      msg.setAccountSettings(value);
      break;
    case 21:
      var value = /** @type {!proto.authz.VendorsRole} */ (reader.readEnum());
      msg.setVendors(value);
      break;
    case 22:
      var value = /** @type {!proto.authz.GrcDocumentsRole} */ (reader.readEnum());
      msg.setGrcDocuments(value);
      break;
    case 23:
      var value = /** @type {!proto.authz.PlaybooksRole} */ (reader.readEnum());
      msg.setPlaybooks(value);
      break;
    case 24:
      var value = /** @type {!proto.authz.AccessRolesRole} */ (reader.readEnum());
      msg.setAccessRoles(value);
      break;
    case 25:
      var value = /** @type {!proto.authz.DepartmentsRole} */ (reader.readEnum());
      msg.setDepartments(value);
      break;
    case 26:
      var value = /** @type {!proto.authz.CompanyInfoRole} */ (reader.readEnum());
      msg.setCompanyInfo(value);
      break;
    case 27:
      var value = /** @type {!proto.authz.SchedulesRole} */ (reader.readEnum());
      msg.setSchedules(value);
      break;
    case 28:
      var value = /** @type {!proto.authz.ContentVersionsRole} */ (reader.readEnum());
      msg.setContentVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.DomainRoles.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.DomainRoles.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.DomainRoles} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.DomainRoles.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControls();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPolicies();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEvidence();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRisks();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getServices();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getReceptors();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getFrameworks();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getAudits();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getRequests();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getReports();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getRoadmap();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getDashboards();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getUsers();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getScope();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getAccountDetails();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getAuditScans();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getChats();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getTrustPortal();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getQuestionnaires();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getAccountSettings();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getVendors();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getGrcDocuments();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getPlaybooks();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getAccessRoles();
  if (f !== 0.0) {
    writer.writeEnum(
      24,
      f
    );
  }
  f = message.getDepartments();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getCompanyInfo();
  if (f !== 0.0) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = message.getSchedules();
  if (f !== 0.0) {
    writer.writeEnum(
      27,
      f
    );
  }
  f = message.getContentVersions();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
};


/**
 * optional ControlsRole controls = 1;
 * @return {!proto.authz.ControlsRole}
 */
proto.authz.DomainRoles.prototype.getControls = function() {
  return /** @type {!proto.authz.ControlsRole} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.authz.ControlsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setControls = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional PoliciesRole policies = 2;
 * @return {!proto.authz.PoliciesRole}
 */
proto.authz.DomainRoles.prototype.getPolicies = function() {
  return /** @type {!proto.authz.PoliciesRole} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.authz.PoliciesRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setPolicies = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional EvidenceRole evidence = 3;
 * @return {!proto.authz.EvidenceRole}
 */
proto.authz.DomainRoles.prototype.getEvidence = function() {
  return /** @type {!proto.authz.EvidenceRole} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.authz.EvidenceRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setEvidence = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional RisksRole risks = 4;
 * @return {!proto.authz.RisksRole}
 */
proto.authz.DomainRoles.prototype.getRisks = function() {
  return /** @type {!proto.authz.RisksRole} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.authz.RisksRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setRisks = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ServicesRole services = 5;
 * @return {!proto.authz.ServicesRole}
 */
proto.authz.DomainRoles.prototype.getServices = function() {
  return /** @type {!proto.authz.ServicesRole} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.authz.ServicesRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setServices = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional ReceptorsRole receptors = 6;
 * @return {!proto.authz.ReceptorsRole}
 */
proto.authz.DomainRoles.prototype.getReceptors = function() {
  return /** @type {!proto.authz.ReceptorsRole} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.authz.ReceptorsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setReceptors = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional FrameworksRole frameworks = 7;
 * @return {!proto.authz.FrameworksRole}
 */
proto.authz.DomainRoles.prototype.getFrameworks = function() {
  return /** @type {!proto.authz.FrameworksRole} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.authz.FrameworksRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setFrameworks = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional AuditsRole audits = 8;
 * @return {!proto.authz.AuditsRole}
 */
proto.authz.DomainRoles.prototype.getAudits = function() {
  return /** @type {!proto.authz.AuditsRole} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.authz.AuditsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setAudits = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional RequestsRole requests = 9;
 * @return {!proto.authz.RequestsRole}
 */
proto.authz.DomainRoles.prototype.getRequests = function() {
  return /** @type {!proto.authz.RequestsRole} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.authz.RequestsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setRequests = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional ReportsRole reports = 10;
 * @return {!proto.authz.ReportsRole}
 */
proto.authz.DomainRoles.prototype.getReports = function() {
  return /** @type {!proto.authz.ReportsRole} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.authz.ReportsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setReports = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional RoadmapRole roadmap = 11;
 * @return {!proto.authz.RoadmapRole}
 */
proto.authz.DomainRoles.prototype.getRoadmap = function() {
  return /** @type {!proto.authz.RoadmapRole} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.authz.RoadmapRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setRoadmap = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional DashboardsRole dashboards = 12;
 * @return {!proto.authz.DashboardsRole}
 */
proto.authz.DomainRoles.prototype.getDashboards = function() {
  return /** @type {!proto.authz.DashboardsRole} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.authz.DashboardsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setDashboards = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional UsersRole users = 13;
 * @return {!proto.authz.UsersRole}
 */
proto.authz.DomainRoles.prototype.getUsers = function() {
  return /** @type {!proto.authz.UsersRole} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.authz.UsersRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setUsers = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional ScopeRole scope = 14;
 * @return {!proto.authz.ScopeRole}
 */
proto.authz.DomainRoles.prototype.getScope = function() {
  return /** @type {!proto.authz.ScopeRole} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.authz.ScopeRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional AccountDetailsRole account_details = 15;
 * @return {!proto.authz.AccountDetailsRole}
 */
proto.authz.DomainRoles.prototype.getAccountDetails = function() {
  return /** @type {!proto.authz.AccountDetailsRole} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.authz.AccountDetailsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setAccountDetails = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional AuditScanRole audit_scans = 16;
 * @return {!proto.authz.AuditScanRole}
 */
proto.authz.DomainRoles.prototype.getAuditScans = function() {
  return /** @type {!proto.authz.AuditScanRole} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.authz.AuditScanRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setAuditScans = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional ChatsRole chats = 17;
 * @return {!proto.authz.ChatsRole}
 */
proto.authz.DomainRoles.prototype.getChats = function() {
  return /** @type {!proto.authz.ChatsRole} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.authz.ChatsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setChats = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional TrustPortalRole trust_portal = 18;
 * @return {!proto.authz.TrustPortalRole}
 */
proto.authz.DomainRoles.prototype.getTrustPortal = function() {
  return /** @type {!proto.authz.TrustPortalRole} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.authz.TrustPortalRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setTrustPortal = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional QuestionnairesRole questionnaires = 19;
 * @return {!proto.authz.QuestionnairesRole}
 */
proto.authz.DomainRoles.prototype.getQuestionnaires = function() {
  return /** @type {!proto.authz.QuestionnairesRole} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.authz.QuestionnairesRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setQuestionnaires = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional AccountSettingsRole account_settings = 20;
 * @return {!proto.authz.AccountSettingsRole}
 */
proto.authz.DomainRoles.prototype.getAccountSettings = function() {
  return /** @type {!proto.authz.AccountSettingsRole} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.authz.AccountSettingsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setAccountSettings = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional VendorsRole vendors = 21;
 * @return {!proto.authz.VendorsRole}
 */
proto.authz.DomainRoles.prototype.getVendors = function() {
  return /** @type {!proto.authz.VendorsRole} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.authz.VendorsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setVendors = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional GrcDocumentsRole grc_documents = 22;
 * @return {!proto.authz.GrcDocumentsRole}
 */
proto.authz.DomainRoles.prototype.getGrcDocuments = function() {
  return /** @type {!proto.authz.GrcDocumentsRole} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.authz.GrcDocumentsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setGrcDocuments = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional PlaybooksRole playbooks = 23;
 * @return {!proto.authz.PlaybooksRole}
 */
proto.authz.DomainRoles.prototype.getPlaybooks = function() {
  return /** @type {!proto.authz.PlaybooksRole} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.authz.PlaybooksRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setPlaybooks = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional AccessRolesRole access_roles = 24;
 * @return {!proto.authz.AccessRolesRole}
 */
proto.authz.DomainRoles.prototype.getAccessRoles = function() {
  return /** @type {!proto.authz.AccessRolesRole} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {!proto.authz.AccessRolesRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setAccessRoles = function(value) {
  return jspb.Message.setProto3EnumField(this, 24, value);
};


/**
 * optional DepartmentsRole departments = 25;
 * @return {!proto.authz.DepartmentsRole}
 */
proto.authz.DomainRoles.prototype.getDepartments = function() {
  return /** @type {!proto.authz.DepartmentsRole} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.authz.DepartmentsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setDepartments = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional CompanyInfoRole company_info = 26;
 * @return {!proto.authz.CompanyInfoRole}
 */
proto.authz.DomainRoles.prototype.getCompanyInfo = function() {
  return /** @type {!proto.authz.CompanyInfoRole} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.authz.CompanyInfoRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setCompanyInfo = function(value) {
  return jspb.Message.setProto3EnumField(this, 26, value);
};


/**
 * optional SchedulesRole schedules = 27;
 * @return {!proto.authz.SchedulesRole}
 */
proto.authz.DomainRoles.prototype.getSchedules = function() {
  return /** @type {!proto.authz.SchedulesRole} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {!proto.authz.SchedulesRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setSchedules = function(value) {
  return jspb.Message.setProto3EnumField(this, 27, value);
};


/**
 * optional ContentVersionsRole content_versions = 28;
 * @return {!proto.authz.ContentVersionsRole}
 */
proto.authz.DomainRoles.prototype.getContentVersions = function() {
  return /** @type {!proto.authz.ContentVersionsRole} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.authz.ContentVersionsRole} value
 * @return {!proto.authz.DomainRoles} returns this
 */
proto.authz.DomainRoles.prototype.setContentVersions = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.authz.PermissionOverrides.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.PermissionOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.PermissionOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.PermissionOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.PermissionOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
    permissionOveridesList: jspb.Message.toObjectList(msg.getPermissionOveridesList(),
    authz_permissions_pb.Permission.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.PermissionOverrides}
 */
proto.authz.PermissionOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.PermissionOverrides;
  return proto.authz.PermissionOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.PermissionOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.PermissionOverrides}
 */
proto.authz.PermissionOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new authz_permissions_pb.Permission;
      reader.readMessage(value,authz_permissions_pb.Permission.deserializeBinaryFromReader);
      msg.addPermissionOverides(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.PermissionOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.PermissionOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.PermissionOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.PermissionOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermissionOveridesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      authz_permissions_pb.Permission.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Permission permission_overides = 1;
 * @return {!Array<!proto.authz.Permission>}
 */
proto.authz.PermissionOverrides.prototype.getPermissionOveridesList = function() {
  return /** @type{!Array<!proto.authz.Permission>} */ (
    jspb.Message.getRepeatedWrapperField(this, authz_permissions_pb.Permission, 1));
};


/**
 * @param {!Array<!proto.authz.Permission>} value
 * @return {!proto.authz.PermissionOverrides} returns this
*/
proto.authz.PermissionOverrides.prototype.setPermissionOveridesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.authz.Permission=} opt_value
 * @param {number=} opt_index
 * @return {!proto.authz.Permission}
 */
proto.authz.PermissionOverrides.prototype.addPermissionOverides = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.authz.Permission, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.PermissionOverrides} returns this
 */
proto.authz.PermissionOverrides.prototype.clearPermissionOveridesList = function() {
  return this.setPermissionOveridesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.authz.AccessRole.repeatedFields_ = [8,9,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.AccessRole.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.AccessRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.AccessRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.AccessRole.toObject = function(includeInstance, msg) {
  var f, obj = {
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    baseAccessRole: jspb.Message.getFieldWithDefault(msg, 5, 0),
    isDefault: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    domainOverrides: (f = msg.getDomainOverrides()) && proto.authz.DomainRoles.toObject(includeInstance, f),
    readOnlyLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    contentRestrictedLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    noAccessLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.AccessRole}
 */
proto.authz.AccessRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.AccessRole;
  return proto.authz.AccessRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.AccessRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.AccessRole}
 */
proto.authz.AccessRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {!proto.authz.BASE_ACCESS_ROLE} */ (reader.readEnum());
      msg.setBaseAccessRole(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDefault(value);
      break;
    case 7:
      var value = new proto.authz.DomainRoles;
      reader.readMessage(value,proto.authz.DomainRoles.deserializeBinaryFromReader);
      msg.setDomainOverrides(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addReadOnlyLabelIds(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addContentRestrictedLabelIds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addNoAccessLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.AccessRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.AccessRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.AccessRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.AccessRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBaseAccessRole();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIsDefault();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getDomainOverrides();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.authz.DomainRoles.serializeBinaryToWriter
    );
  }
  f = message.getReadOnlyLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getContentRestrictedLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getNoAccessLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp created_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.authz.AccessRole.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.authz.AccessRole} returns this
*/
proto.authz.AccessRole.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.AccessRole.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.authz.AccessRole.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.authz.AccessRole} returns this
*/
proto.authz.AccessRole.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.AccessRole.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.authz.AccessRole.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.authz.AccessRole.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional BASE_ACCESS_ROLE base_access_role = 5;
 * @return {!proto.authz.BASE_ACCESS_ROLE}
 */
proto.authz.AccessRole.prototype.getBaseAccessRole = function() {
  return /** @type {!proto.authz.BASE_ACCESS_ROLE} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.authz.BASE_ACCESS_ROLE} value
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.setBaseAccessRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool is_default = 6;
 * @return {boolean}
 */
proto.authz.AccessRole.prototype.getIsDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.setIsDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional DomainRoles domain_overrides = 7;
 * @return {?proto.authz.DomainRoles}
 */
proto.authz.AccessRole.prototype.getDomainOverrides = function() {
  return /** @type{?proto.authz.DomainRoles} */ (
    jspb.Message.getWrapperField(this, proto.authz.DomainRoles, 7));
};


/**
 * @param {?proto.authz.DomainRoles|undefined} value
 * @return {!proto.authz.AccessRole} returns this
*/
proto.authz.AccessRole.prototype.setDomainOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.clearDomainOverrides = function() {
  return this.setDomainOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.AccessRole.prototype.hasDomainOverrides = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated string read_only_label_ids = 8;
 * @return {!Array<string>}
 */
proto.authz.AccessRole.prototype.getReadOnlyLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.setReadOnlyLabelIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.addReadOnlyLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.clearReadOnlyLabelIdsList = function() {
  return this.setReadOnlyLabelIdsList([]);
};


/**
 * repeated string content_restricted_label_ids = 9;
 * @return {!Array<string>}
 */
proto.authz.AccessRole.prototype.getContentRestrictedLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.setContentRestrictedLabelIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.addContentRestrictedLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.clearContentRestrictedLabelIdsList = function() {
  return this.setContentRestrictedLabelIdsList([]);
};


/**
 * repeated string no_access_label_ids = 10;
 * @return {!Array<string>}
 */
proto.authz.AccessRole.prototype.getNoAccessLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.setNoAccessLabelIdsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.addNoAccessLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.AccessRole} returns this
 */
proto.authz.AccessRole.prototype.clearNoAccessLabelIdsList = function() {
  return this.setNoAccessLabelIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.authz.GetPermissionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.GetPermissionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.GetPermissionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.GetPermissionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.GetPermissionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    permissionsList: jspb.Message.toObjectList(msg.getPermissionsList(),
    authz_permissions_pb.Permission.toObject, includeInstance),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.GetPermissionsResponse}
 */
proto.authz.GetPermissionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.GetPermissionsResponse;
  return proto.authz.GetPermissionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.GetPermissionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.GetPermissionsResponse}
 */
proto.authz.GetPermissionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new authz_permissions_pb.Permission;
      reader.readMessage(value,authz_permissions_pb.Permission.deserializeBinaryFromReader);
      msg.addPermissions(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.GetPermissionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.GetPermissionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.GetPermissionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.GetPermissionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      authz_permissions_pb.Permission.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated Permission permissions = 1;
 * @return {!Array<!proto.authz.Permission>}
 */
proto.authz.GetPermissionsResponse.prototype.getPermissionsList = function() {
  return /** @type{!Array<!proto.authz.Permission>} */ (
    jspb.Message.getRepeatedWrapperField(this, authz_permissions_pb.Permission, 1));
};


/**
 * @param {!Array<!proto.authz.Permission>} value
 * @return {!proto.authz.GetPermissionsResponse} returns this
*/
proto.authz.GetPermissionsResponse.prototype.setPermissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.authz.Permission=} opt_value
 * @param {number=} opt_index
 * @return {!proto.authz.Permission}
 */
proto.authz.GetPermissionsResponse.prototype.addPermissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.authz.Permission, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.GetPermissionsResponse} returns this
 */
proto.authz.GetPermissionsResponse.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};


/**
 * optional int64 version = 2;
 * @return {number}
 */
proto.authz.GetPermissionsResponse.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.authz.GetPermissionsResponse} returns this
 */
proto.authz.GetPermissionsResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.GetAccessRolesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.GetAccessRolesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.GetAccessRolesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.GetAccessRolesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    includeNoAccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.GetAccessRolesRequest}
 */
proto.authz.GetAccessRolesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.GetAccessRolesRequest;
  return proto.authz.GetAccessRolesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.GetAccessRolesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.GetAccessRolesRequest}
 */
proto.authz.GetAccessRolesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeNoAccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.GetAccessRolesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.GetAccessRolesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.GetAccessRolesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.GetAccessRolesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludeNoAccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool include_no_access = 1;
 * @return {boolean}
 */
proto.authz.GetAccessRolesRequest.prototype.getIncludeNoAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.authz.GetAccessRolesRequest} returns this
 */
proto.authz.GetAccessRolesRequest.prototype.setIncludeNoAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.authz.GetAccessRolesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.GetAccessRolesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.GetAccessRolesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.GetAccessRolesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.GetAccessRolesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessRolesList: jspb.Message.toObjectList(msg.getAccessRolesList(),
    proto.authz.AccessRole.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.GetAccessRolesResponse}
 */
proto.authz.GetAccessRolesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.GetAccessRolesResponse;
  return proto.authz.GetAccessRolesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.GetAccessRolesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.GetAccessRolesResponse}
 */
proto.authz.GetAccessRolesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.authz.AccessRole;
      reader.readMessage(value,proto.authz.AccessRole.deserializeBinaryFromReader);
      msg.addAccessRoles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.GetAccessRolesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.GetAccessRolesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.GetAccessRolesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.GetAccessRolesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.authz.AccessRole.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccessRole access_roles = 1;
 * @return {!Array<!proto.authz.AccessRole>}
 */
proto.authz.GetAccessRolesResponse.prototype.getAccessRolesList = function() {
  return /** @type{!Array<!proto.authz.AccessRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.authz.AccessRole, 1));
};


/**
 * @param {!Array<!proto.authz.AccessRole>} value
 * @return {!proto.authz.GetAccessRolesResponse} returns this
*/
proto.authz.GetAccessRolesResponse.prototype.setAccessRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.authz.AccessRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.authz.AccessRole}
 */
proto.authz.GetAccessRolesResponse.prototype.addAccessRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.authz.AccessRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.GetAccessRolesResponse} returns this
 */
proto.authz.GetAccessRolesResponse.prototype.clearAccessRolesList = function() {
  return this.setAccessRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.BaseAccessRoleUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.BaseAccessRoleUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.BaseAccessRoleUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.BaseAccessRoleUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    role: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.BaseAccessRoleUpdate}
 */
proto.authz.BaseAccessRoleUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.BaseAccessRoleUpdate;
  return proto.authz.BaseAccessRoleUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.BaseAccessRoleUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.BaseAccessRoleUpdate}
 */
proto.authz.BaseAccessRoleUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.authz.BASE_ACCESS_ROLE} */ (reader.readEnum());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.BaseAccessRoleUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.BaseAccessRoleUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.BaseAccessRoleUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.BaseAccessRoleUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional BASE_ACCESS_ROLE role = 1;
 * @return {!proto.authz.BASE_ACCESS_ROLE}
 */
proto.authz.BaseAccessRoleUpdate.prototype.getRole = function() {
  return /** @type {!proto.authz.BASE_ACCESS_ROLE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.authz.BASE_ACCESS_ROLE} value
 * @return {!proto.authz.BaseAccessRoleUpdate} returns this
 */
proto.authz.BaseAccessRoleUpdate.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.authz.CreateAccessRoleRequest.repeatedFields_ = [6,7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.CreateAccessRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.CreateAccessRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.CreateAccessRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.CreateAccessRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    baseAccessRole: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isDefault: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    domainOverrides: (f = msg.getDomainOverrides()) && proto.authz.DomainRoles.toObject(includeInstance, f),
    permissionOverrides: (f = msg.getPermissionOverrides()) && authz_permissions_pb.Permissions.toObject(includeInstance, f),
    readOnlyLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    contentRestrictedLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    noAccessLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.CreateAccessRoleRequest}
 */
proto.authz.CreateAccessRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.CreateAccessRoleRequest;
  return proto.authz.CreateAccessRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.CreateAccessRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.CreateAccessRoleRequest}
 */
proto.authz.CreateAccessRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.authz.BASE_ACCESS_ROLE} */ (reader.readEnum());
      msg.setBaseAccessRole(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDefault(value);
      break;
    case 4:
      var value = new proto.authz.DomainRoles;
      reader.readMessage(value,proto.authz.DomainRoles.deserializeBinaryFromReader);
      msg.setDomainOverrides(value);
      break;
    case 5:
      var value = new authz_permissions_pb.Permissions;
      reader.readMessage(value,authz_permissions_pb.Permissions.deserializeBinaryFromReader);
      msg.setPermissionOverrides(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addReadOnlyLabelIds(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addContentRestrictedLabelIds(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addNoAccessLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.CreateAccessRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.CreateAccessRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.CreateAccessRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.CreateAccessRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBaseAccessRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsDefault();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getDomainOverrides();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.authz.DomainRoles.serializeBinaryToWriter
    );
  }
  f = message.getPermissionOverrides();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      authz_permissions_pb.Permissions.serializeBinaryToWriter
    );
  }
  f = message.getReadOnlyLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getContentRestrictedLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getNoAccessLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.authz.CreateAccessRoleRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BASE_ACCESS_ROLE base_access_role = 2;
 * @return {!proto.authz.BASE_ACCESS_ROLE}
 */
proto.authz.CreateAccessRoleRequest.prototype.getBaseAccessRole = function() {
  return /** @type {!proto.authz.BASE_ACCESS_ROLE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.authz.BASE_ACCESS_ROLE} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.setBaseAccessRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool is_default = 3;
 * @return {boolean}
 */
proto.authz.CreateAccessRoleRequest.prototype.getIsDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.setIsDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional DomainRoles domain_overrides = 4;
 * @return {?proto.authz.DomainRoles}
 */
proto.authz.CreateAccessRoleRequest.prototype.getDomainOverrides = function() {
  return /** @type{?proto.authz.DomainRoles} */ (
    jspb.Message.getWrapperField(this, proto.authz.DomainRoles, 4));
};


/**
 * @param {?proto.authz.DomainRoles|undefined} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
*/
proto.authz.CreateAccessRoleRequest.prototype.setDomainOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.clearDomainOverrides = function() {
  return this.setDomainOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.CreateAccessRoleRequest.prototype.hasDomainOverrides = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Permissions permission_overrides = 5;
 * @return {?proto.authz.Permissions}
 */
proto.authz.CreateAccessRoleRequest.prototype.getPermissionOverrides = function() {
  return /** @type{?proto.authz.Permissions} */ (
    jspb.Message.getWrapperField(this, authz_permissions_pb.Permissions, 5));
};


/**
 * @param {?proto.authz.Permissions|undefined} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
*/
proto.authz.CreateAccessRoleRequest.prototype.setPermissionOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.clearPermissionOverrides = function() {
  return this.setPermissionOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.CreateAccessRoleRequest.prototype.hasPermissionOverrides = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string read_only_label_ids = 6;
 * @return {!Array<string>}
 */
proto.authz.CreateAccessRoleRequest.prototype.getReadOnlyLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.setReadOnlyLabelIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.addReadOnlyLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.clearReadOnlyLabelIdsList = function() {
  return this.setReadOnlyLabelIdsList([]);
};


/**
 * repeated string content_restricted_label_ids = 7;
 * @return {!Array<string>}
 */
proto.authz.CreateAccessRoleRequest.prototype.getContentRestrictedLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.setContentRestrictedLabelIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.addContentRestrictedLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.clearContentRestrictedLabelIdsList = function() {
  return this.setContentRestrictedLabelIdsList([]);
};


/**
 * repeated string no_access_label_ids = 8;
 * @return {!Array<string>}
 */
proto.authz.CreateAccessRoleRequest.prototype.getNoAccessLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.setNoAccessLabelIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.addNoAccessLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.CreateAccessRoleRequest} returns this
 */
proto.authz.CreateAccessRoleRequest.prototype.clearNoAccessLabelIdsList = function() {
  return this.setNoAccessLabelIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.authz.UpdateAccessRoleRequest.repeatedFields_ = [7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.UpdateAccessRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.UpdateAccessRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.UpdateAccessRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.UpdateAccessRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    baseAccessRole: (f = msg.getBaseAccessRole()) && proto.authz.BaseAccessRoleUpdate.toObject(includeInstance, f),
    isDefault: (f = msg.getIsDefault()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    domainOverrides: (f = msg.getDomainOverrides()) && proto.authz.DomainRoles.toObject(includeInstance, f),
    permissionOverrides: (f = msg.getPermissionOverrides()) && authz_permissions_pb.Permissions.toObject(includeInstance, f),
    readOnlyLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    contentRestrictedLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    noAccessLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.UpdateAccessRoleRequest}
 */
proto.authz.UpdateAccessRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.UpdateAccessRoleRequest;
  return proto.authz.UpdateAccessRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.UpdateAccessRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.UpdateAccessRoleRequest}
 */
proto.authz.UpdateAccessRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.authz.BaseAccessRoleUpdate;
      reader.readMessage(value,proto.authz.BaseAccessRoleUpdate.deserializeBinaryFromReader);
      msg.setBaseAccessRole(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsDefault(value);
      break;
    case 5:
      var value = new proto.authz.DomainRoles;
      reader.readMessage(value,proto.authz.DomainRoles.deserializeBinaryFromReader);
      msg.setDomainOverrides(value);
      break;
    case 6:
      var value = new authz_permissions_pb.Permissions;
      reader.readMessage(value,authz_permissions_pb.Permissions.deserializeBinaryFromReader);
      msg.setPermissionOverrides(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addReadOnlyLabelIds(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addContentRestrictedLabelIds(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addNoAccessLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.UpdateAccessRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.UpdateAccessRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.UpdateAccessRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.UpdateAccessRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBaseAccessRole();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.authz.BaseAccessRoleUpdate.serializeBinaryToWriter
    );
  }
  f = message.getIsDefault();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getDomainOverrides();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.authz.DomainRoles.serializeBinaryToWriter
    );
  }
  f = message.getPermissionOverrides();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      authz_permissions_pb.Permissions.serializeBinaryToWriter
    );
  }
  f = message.getReadOnlyLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getContentRestrictedLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getNoAccessLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional BaseAccessRoleUpdate base_access_role = 3;
 * @return {?proto.authz.BaseAccessRoleUpdate}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getBaseAccessRole = function() {
  return /** @type{?proto.authz.BaseAccessRoleUpdate} */ (
    jspb.Message.getWrapperField(this, proto.authz.BaseAccessRoleUpdate, 3));
};


/**
 * @param {?proto.authz.BaseAccessRoleUpdate|undefined} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
*/
proto.authz.UpdateAccessRoleRequest.prototype.setBaseAccessRole = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.clearBaseAccessRole = function() {
  return this.setBaseAccessRole(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.UpdateAccessRoleRequest.prototype.hasBaseAccessRole = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue is_default = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getIsDefault = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
*/
proto.authz.UpdateAccessRoleRequest.prototype.setIsDefault = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.clearIsDefault = function() {
  return this.setIsDefault(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.UpdateAccessRoleRequest.prototype.hasIsDefault = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DomainRoles domain_overrides = 5;
 * @return {?proto.authz.DomainRoles}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getDomainOverrides = function() {
  return /** @type{?proto.authz.DomainRoles} */ (
    jspb.Message.getWrapperField(this, proto.authz.DomainRoles, 5));
};


/**
 * @param {?proto.authz.DomainRoles|undefined} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
*/
proto.authz.UpdateAccessRoleRequest.prototype.setDomainOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.clearDomainOverrides = function() {
  return this.setDomainOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.UpdateAccessRoleRequest.prototype.hasDomainOverrides = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Permissions permission_overrides = 6;
 * @return {?proto.authz.Permissions}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getPermissionOverrides = function() {
  return /** @type{?proto.authz.Permissions} */ (
    jspb.Message.getWrapperField(this, authz_permissions_pb.Permissions, 6));
};


/**
 * @param {?proto.authz.Permissions|undefined} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
*/
proto.authz.UpdateAccessRoleRequest.prototype.setPermissionOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.clearPermissionOverrides = function() {
  return this.setPermissionOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.authz.UpdateAccessRoleRequest.prototype.hasPermissionOverrides = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated string read_only_label_ids = 7;
 * @return {!Array<string>}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getReadOnlyLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.setReadOnlyLabelIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.addReadOnlyLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.clearReadOnlyLabelIdsList = function() {
  return this.setReadOnlyLabelIdsList([]);
};


/**
 * repeated string content_restricted_label_ids = 8;
 * @return {!Array<string>}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getContentRestrictedLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.setContentRestrictedLabelIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.addContentRestrictedLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.clearContentRestrictedLabelIdsList = function() {
  return this.setContentRestrictedLabelIdsList([]);
};


/**
 * repeated string no_access_label_ids = 9;
 * @return {!Array<string>}
 */
proto.authz.UpdateAccessRoleRequest.prototype.getNoAccessLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.setNoAccessLabelIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.addNoAccessLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.UpdateAccessRoleRequest} returns this
 */
proto.authz.UpdateAccessRoleRequest.prototype.clearNoAccessLabelIdsList = function() {
  return this.setNoAccessLabelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.DeleteAccessRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.DeleteAccessRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.DeleteAccessRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.DeleteAccessRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.DeleteAccessRoleRequest}
 */
proto.authz.DeleteAccessRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.DeleteAccessRoleRequest;
  return proto.authz.DeleteAccessRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.DeleteAccessRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.DeleteAccessRoleRequest}
 */
proto.authz.DeleteAccessRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.DeleteAccessRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.DeleteAccessRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.DeleteAccessRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.DeleteAccessRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.authz.DeleteAccessRoleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.authz.DeleteAccessRoleRequest} returns this
 */
proto.authz.DeleteAccessRoleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.authz.BASE_ACCESS_ROLE = {
  ADMIN: 0,
  USER: 1,
  AUDITOR: 2,
  AUDITOR_QC: 3,
  READ_ONLY: 4,
  TP_PUBLISHER: 5,
  TP_APPROVER: 6,
  NO_ACCESS: 7
};

goog.object.extend(exports, proto.authz);
